import React, { useState } from 'react';
import { oneOfType, array, object, number, string } from 'prop-types';
import { get, head, filter, replace, includes } from 'lodash';
import { Modal as ModalConfirm } from 'antd';
import { FlexContainer, Text, Button, AppIcon, FormInput, ConfirmFooterButtons, Number, HasPermissions, IconContainer, Icon, Modal, Column } from '../../common';
import { Mutation } from '../../graphql';
import { UPDATE_SHIPPING_PRICE } from '../../../queries';
import { currentUserInfo } from '../../../utils/misc';

const ModifyPrice = ({ data, status }) => {
    const [showModifyPrice, setShowModifyPrice] = useState(false);
    const [showModalConfirm, setShowModalConfirm] = useState(false);
    const priceShipping = parseInt(get(head(filter(get(data, 'totals', []), ({ id }) => id === 'shipping')), 'value', data));
    const [price, setPrice] = useState(priceShipping);
    const clearPrice = (price) => parseInt(replace(price, /\$|\./gi, ''));
    const isValidPrice = price >= 0 && price <= priceShipping;

    const isValidStatus = includes(['1', '2', '3', '4', '7', '20', '30', '32'], get(data, 'assignInfo.status.code', status));
    const onClose = () => {
        setShowModifyPrice(false);
        setPrice(priceShipping);
    };

    const modalConfirm = (loading, onConfirm) => {
        return <ModalConfirm
            footer={null}
            visible={showModalConfirm}
            onCancel={() => setShowModalConfirm(false)}
            width={400}
        >
            <Column center mB={70}>
                <IconContainer color='#f38630' margin='0 0 40px 0'>
                    <Icon name='caution' size={43} color='#ffffff' />
                </IconContainer>
                <Text text='¿Estas seguro de disminuir el valor de Despacho?' size={14} centered />
                <Text text='Una vez modificado, no puedes volver atrás.' size={14} centered />
            </Column>
            <ConfirmFooterButtons
                loading={loading}
                onCancel={() => setShowModalConfirm(false)}
                onConfirm={async () => onConfirm()}
            />
        </ModalConfirm>;
    };

    if (!isValidStatus) return <Text text={<Number value={priceShipping} />} />;

    return (
        <>
            <FlexContainer align='center'>
                <Text text={<Number value={priceShipping} />} />
                <HasPermissions to={['order-detail-page:modify-dispatch-price']}>
                    <Button
                        link
                        style={{ border: 'none', minHeight: '20px' }}
                        backgroundColor='transparent'
                        width={30}
                        onClick={() => setShowModifyPrice(true)}
                    >
                        <AppIcon name='ic-edit' size='12' />
                    </Button>
                </HasPermissions>
            </FlexContainer>
            <Modal
                title='Modificar costo de entrega'
                visible={showModifyPrice}
                onClose={onClose}
                width={400}
            >
                <Mutation
                    mutation={UPDATE_SHIPPING_PRICE}
                    refetchQueries={['getOrderById', 'getOrderItems', 'getPickingInfoBy']}
                    onCompleted={() => {
                        onClose();
                        setPrice(clearPrice(price));
                        setShowModalConfirm(false)
                    }}
                >
                    {({ updateFn, loading, data: response }) => {
                        const onConfirm = async () => updateFn({
                            variables: {
                                input: {
                                    idOrder: get(data, 'id', null),
                                    user: get(await currentUserInfo(), 'email'),
                                    originalPrice: priceShipping,
                                    newPrice: clearPrice(price)
                                }
                            }
                        });

                        return <>
                            <FlexContainer height={145}>
                                <FormInput
                                    label='Precio'
                                    isPrice
                                    value={price}
                                    onChange={({ target }) => {
                                        const value = clearPrice(get(target, 'value')) || 0;
                                        setPrice(clearPrice(value));
                                    }}
                                    error={!isValidPrice && 'Precio no válido'}
                                />
                            </FlexContainer>
                            <ConfirmFooterButtons
                                confirmDisabled={(clearPrice(price) === priceShipping) || !isValidPrice}
                                onCancel={onClose}
                                confirmLabel='Confirmar'
                                onConfirm={() => setShowModalConfirm(true)}
                            />
                            {modalConfirm(loading, onConfirm)}
                        </>;
                    }}
                </Mutation>
            </Modal>
        </>
    );
};

ModifyPrice.propTypes = {
    data: oneOfType([array, object, number, string]),
    status: oneOfType([string, number])
};

export default ModifyPrice;
